import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCheckboxIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1.5, y: 1.5, width: 21, height: 21, rx: 3.5, fill: "white", stroke: "#9E9FAC" }));
const ForwardRef = forwardRef(SvgCheckboxIcon);
const Memo = memo(ForwardRef);
export default Memo;
